module.exports = __webpack_public_path__ + "static/img/API.04c2e4a.webp";


//////////////////
// WEBPACK FOOTER
// ./static/images2/API.webp
// module id = Ql54
// module chunks = 2